
export default {
  props: {
    anchor: {
      type: String,
      default: "#content",
    },
  },
};
